import { z } from 'zod';
import { ProcessStepRecordingSchema, StepHelpersSchema, StepSuccessorsSchema, StepDecisionRuleSchema, StepInputSchema, WhoElseDoesThisItemSchema, RecordingStatusSchema } from '../../entities/process-step-recording';
import { StepActionTypeSchema } from '../../shared/step-action-type.schema';
import { AssigneeModelSchema } from '../../shared/assignee-model.schema';
/**
 * Edit Process Step Recording Request Schema
 * PATCH /api/v2/process-step-recording/:id
 * All fields are optional - only provided fields will be updated
 *
 * Uses unpopulated schemas (string IDs) for fields that accept references.
 * This is separate from the response schema which returns populated objects.
 *
 * `surveys` is deliberately absent: surveys are answered by performers and
 * joined server-side (show-process only, behind the sensitive-fields gate), so
 * a recorder editing their step must never be able to submit them.
 */ export const EditProcessStepRecordingRequestSchema = z.object({
    previousStep: z.string().optional(),
    assignedTo: z.string().optional(),
    assignedToModel: AssigneeModelSchema.optional(),
    whoElseDoesThis: z.array(WhoElseDoesThisItemSchema).optional(),
    inputs: z.array(StepInputSchema).optional(),
    actionType: StepActionTypeSchema.optional(),
    helpers: StepHelpersSchema.optional(),
    task: z.object({
        taskDescription: z.string().optional(),
        output: z.string().optional(),
        successors: StepSuccessorsSchema.optional()
    }).optional(),
    rules: z.array(StepDecisionRuleSchema).optional(),
    recordingCompletedAt: z.number().optional(),
    status: RecordingStatusSchema.optional(),
    generatedName: z.string().optional(),
    generatedDescription: z.string().optional()
}).partial();
/**
 * Edit Process Step Recording Response Schema
 * Returned on successful process step recording update
 * Contains the updated process step recording object with IDs (not populated)
 * Uses minimal schema since the recording page works with IDs for form components
 */ export const EditProcessStepRecordingResponseSchema = z.object({
    processStepRecording: ProcessStepRecordingSchema
});
/**
 * Edit Process Step Recording Error Schema
 * Returned when process step recording update fails
 * Contains standard error information
 */ export const EditProcessStepRecordingErrorSchema = z.object({
    statusCode: z.number(),
    message: z.string(),
    error: z.string()
});

//# sourceMappingURL=edit-process-step-recording.schema.js.map